class DocumentoEditorTextoUrlBuilder {
	constructor(tipo) {
		this.PATH = tipo.path
	}

	getUrlInserir() {
		return `api/${this.PATH}/documentos/documentos-editor`
	}

	getUrlRedigir(idDocumento) {
		return `api/${this.PATH}/documentos/documentos-editor/${idDocumento}`
	}

	getUrlVisualizar(idDocumento) {
		return `api/${this.PATH}/documentos/documentos-editor/${idDocumento}`
	}

	getUrlConcluirDocumento(idDocumento) {
		return `api/${this.PATH}/documentos/documentos-editor/${idDocumento}/sincronizar`
	}

	getUrlBuscarPorId(idDocumento) {
		return `api/${this.PATH}/documentos/${idDocumento}/documentos-editor`
	}

	getUrlSincronizar(idDocumento) {
		return `api/${this.PATH}/documentos/documentos-editor/${idDocumento}/sincronizar`
	}
}

export default DocumentoEditorTextoUrlBuilder
